import * as React from "react";

const Download = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer20"
      fill="none"
      fillOpacity="1"
      stroke="#000"
      strokeDasharray="none"
      strokeDashoffset="22.224"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
    >
      <path
        id="path90-5"
        strokeWidth="0.4"
        d="M3.175 1.058v2.583"
        display="inline"
      ></path>
      <path
        id="path92-3"
        strokeWidth="0.267"
        d="m2.53 2.827.557-.624a.117.117.091 0 1 .176 0l.553.624"
        display="inline"
        transform="rotate(180 3.969 3.607)scale(1.5)"
      ></path>
      <path
        id="path97"
        strokeWidth="0.4"
        d="M.53 3.704v1.058a.53.53 45 0 0 .528.53h4.234a.53.53 135 0 0 .529-.53V3.704"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Download;
